<template>
    <div class="clearfix company-form-container reports-tab-nav px-0 employee-table-wrapper">
        <!-- alpha fix- added this and maked pl-3 -->
        <p class="mt-3 pl-3" style="font-size: 15px; padding-bottom: 10px;">Upload, Centralize & Deploy official or
            departmental guidelines and employee handbooks instantly from one powerful command center.</p>
        <div class="p-3 employee-investment-wrapper">
            <b-alert show dismissible fade v-if='successmsg'>{{ successmsg }}</b-alert>

            <div class="row no-gutters py-2 mb-3">
                <div class="col-sm-5 px company-form-box-title">Company Documents & Policies</div>
            </div>
            <div class="row no-gutters py-2 mb-3">
                <div class="col-sm-5">
                    <div class="custom-search">

                        <b-input-group class="mb-2">
                            <b-input-group-prepend is-text>
                                <b-icon icon="search"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input type="search" placeholder="Search ...." v-model="search"
                                @input="resetPagination()"></b-form-input>
                        </b-input-group>

                    </div>
                </div>
                <template v-if="$acl['hr-policy-handbook'] > 1">
                    <div class="col-sm-7 cursor-pointer text-right company-form-box-title" v-if="flg == 1">
                        <button class="btn btn-block btn-secondary tab-button" @click="addNew()">+ Add New</button>
                        <!-- <b-button @click="addNew()"></b-button> -->
                    </div>
                </template>

            </div>

            <!-- Abdullah 13-05-26 added b-overlay  -->
            <b-overlay :show="showoverlay" rounded="sm">
                <table class="table table-list dataTable">
                    <thead>
                        <!-- alpha fix- added sorting icon  -->
                        <tr class="table-head">
                            <template v-for="column in columns">
                                <th v-if="column.name != 'created_at'">
                                    <label class="custom-label mb-0"
                                        :class="sortKey === column.name ? (sortOrders[column.name] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"
                                        @click="sortBy(column.name)" style="cursor:pointer;">
                                        <span>{{ column.label }}</span>
                                    </label>
                                </th>
                            </template>
                            <th>File</th>
                            <th v-if="flg == 1">Action</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr class="hover-bg table-row border-bottom mx-2" v-for="doc in paginatedData" :key="doc.id">
                            <td>{{ doc.name }}</td>

                            <!-- Abdullah 13-05-26 commented this  -->
                            <!-- <td class="text-center">
                                <div class="text-uppercase align-self-center text-center" v-if="doc.file_name">
                                    <b-link @click="downloadFileContent('/data/hrpolicyhandbook/' + doc.company_id + '/' + doc.file_name)">
                                        <img :src="$api_url+'/images/download_image.png'"  class="" />
                                    </b-link>
                                </div>
                            </td> -->

                            <!-- Abdullah 13-05-26 added this  -->
                            <td class="text-center">
                                <div class="text-uppercase align-self-center text-center" v-if="doc.file_name">
                                    <span v-if="downloadingId === doc.id">
                                        <b-spinner small variant="primary" label="Downloading..."></b-spinner>
                                    </span>
                                    <b-link v-else
                                        @click="downloadFileContent('/data/hrpolicyhandbook/' + doc.company_id + '/' + doc.file_name, doc.id)">
                                        <img :src="$api_url + '/images/download_image.png'" class="" />
                                    </b-link>
                                </div>
                            </td>

                            <td class="float-right" v-if="flg == 1">
                                <template v-if="$acl['hr-policy-handbook'] > 1">
                                    <div class="position-relative">
                                        <b-button-toolbar>
                                            <a id="actionDropdown"
                                                class="dropdown-toggle clearfix action-dropdown-toggle"
                                                style="font-size: 16px;" href="#" role="button" data-toggle="dropdown"
                                                aria-haspopup="true" aria-expanded="false"><b-icon
                                                    icon="three-dots-vertical"></b-icon></a>
                                            <div class="dropdown-menu action-dropdown-menu"
                                                aria-labelledby="actionDropdown">
                                                <b-button-group>
                                                    <b-button variant="outline-secondary" @click="editDocument(doc.id)">
                                                        <b-icon icon="pencil"></b-icon> Edit
                                                    </b-button>
                                                    <b-button variant="outline-secondary"
                                                        @click="deleteDocument(doc.id)">
                                                        <b-icon icon="trash"></b-icon> Delete
                                                    </b-button>
                                                </b-button-group>
                                            </div>
                                        </b-button-toolbar>
                                    </div>
                                </template>

                            </td>
                        </tr>

                        <!-- Abdullah 13-04-26 commented this  -->
                        <!-- <tr v-if="paginatedData.length > 0">
                            <td :colspan=6>
                                <div class="row p-2 float-right">
                                    <b-pagination-nav v-model="pagination.currentPage" :number-of-pages="pagination.pages"
                                        base-url="#" first-number last-number></b-pagination-nav>
                                </div>
                            </td>
                        </tr>


                        <tr v-if="paginatedData.length == 0">
                            <td :colspan=6>
                                <div class="mt-4 d-flex justify-content-center"> {{ blankmsg }} </div>
                            </td>
                        </tr> -->
                    </tbody>
                </table>

                <!-- Abdullah 13-04-26 added pagination  -->
                <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell">{{ blankmsg }}</div>
                <div v-else class="row py-2 no-margin">
                    <div class="col-md-12 p-0 no-margin">
                        <ul class="pagination b-pagination float-left mb-0 mt-1">
                            <li class="page-item disabled m-2">View</li>
                            <li class="page-item disabled">
                                <b-form-select v-model="temp_length" :options="length_options"
                                    @change="setFirstPage()"></b-form-select>
                            </li>
                            <li class="page-item disabled m-2">per page. Total {{ pagination.total }} records found.
                            </li>
                        </ul>
                        <b-pagination-nav v-model="pagination.currentPage" :number-of-pages="pagination.pages"
                            base-url="#" prev-text="Previous" next-text="Next" first-number
                            last-number></b-pagination-nav>
                    </div>
                </div>
            </b-overlay>



            <!-- alpha fix- maked title dynamic  -->
            <b-modal id="bv-modal-hr" size="lg" hide-footer no-close-on-backdrop :title=hr_policies>
                <ul>
                    <li clase="text-uppercase" v-for='data in errormsg'>{{ data[0] }}</li>
                </ul>
                <b-overlay :show="showoverlay" rounded="sm">
                    <b-form @submit.stop.prevent="onSubmit">
                        <input type="hidden" v-model="fdata.id" name="id">

                        <!-- alpha fix- added class required-fileds  -->
                        <b-form-group id="name-group" label="Name" class="required-field" label-for="name">
                            <b-form-input id="name" name="name" v-model="fdata.name"
                                v-validate="{ required: true, min: 3 }" :state="validateState('name')"
                                aria-describedby="name-feedback" data-vv-as="Name"></b-form-input>
                            <b-form-invalid-feedback id="name-feedback">{{ veeErrors.first('name')
                                }}</b-form-invalid-feedback>
                        </b-form-group>

                        <b-form-group v-if="departments_option.length > 0">
                            <template #label>
                                <b>Departments:</b><br>
                                <b-form-checkbox v-model="allSelected" :indeterminate="indeterminate"
                                    aria-describedby="departments" aria-controls="departments" @change="toggleAll">
                                    {{ allSelected ? 'Un-select All' : 'Select All' }}
                                </b-form-checkbox>
                            </template>

                            <template v-slot="{ ariaDescribedby }">
                                <b-form-checkbox-group id="departments" v-model="selected" :options="departments_option"
                                    :aria-describedby="ariaDescribedby" name="departments" class="ml-4"
                                    aria-label="Individual departments" stacked></b-form-checkbox-group>
                            </template>
                        </b-form-group>

                        <b-form-group id="upload_file-group" label="File" label-for="upload_file">
                            <b-form-file id="upload_file" v-model="upload_file"
                            @change="checkFileType($event, 'upload_file', ['.jpg', '.png', '.gif', '.pdf', '.doc', '.docx'])"
                                accept=".jpg, .png, .gif, .pdf , .doc , .docx"
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."></b-form-file>

                            <div class="col-sm-2 align-self-center mt-2" v-if="fdata.file_name">
                                <!-- <b-link :href="$api_url + '/data/hrpolicyhandbook/' + fdata.company_id + '/' + fdata.file_name"
                                    target="_blank">
                                    <img :src="$api_url+'/images/download_image.png'"  class="" />
                                </b-link> -->

                                <b-link class="mt-2"
                                    @click="downloadFileContent('/data/hrpolicyhandbook/' + fdata.company_id + '/' + fdata.file_name)">
                                    <!-- <b-icon icon="download" scale="2"></b-icon> -->
                                    <img :src="$api_url + '/images/download_image.png'" class="" />
                                </b-link>
                            </div>
                        </b-form-group>

                        <b-form-group label=" " class="">
                            <div class="text-center">
                                <b-button class="ml-2 custom-wizard-btn" @click="resetForm()">Reset</b-button>
                                <b-button type="submit" variant="primary">Submit</b-button>
                            </div>
                        </b-form-group>
                    </b-form>
                </b-overlay>
            </b-modal>
        </div>


    </div>
</template>


<script>
export default {

    mounted() {

    },
    props: ['flg'],
    data() {

        let sortOrders = {};
        let columns = [
            { label: 'Name', name: 'name' },
            { label: '', name: 'created_at' },

        ];
        columns.forEach((column) => { sortOrders[column.name] = -1; });

        return {

            departments_option: [],

            departments: [],

            selected: [],

            allSelected: false,
            indeterminate: false,



            documents: [],
            successmsg: null,
            errormsg: [],
            showoverlay: false,
            fdata: { id: null, name: null },
            upload_file: null,

            blankmsg: 'Fetching data..',
            search: '',

            columns: columns,
            sortKey: 'name',
            sortOrders: sortOrders,
            length: 10,
            pagination: { currentPage: 1, total: '', nextPage: '', prevPage: '', from: '', to: '', pages: 1 },

            // Abdullah 13-04-26 added this
            length_options: [
                { value: 10, text: "10" },
                { value: 20, text: "20" },
                { value: 50, text: "50" },
                { value: 100, text: "100" }
            ],
            temp_length: 10,
            downloadingId: null,

            // alpha fix- added this
            hr_policies: "Add Company Documents & Policies",

        }
    },
    methods: {
        toggleAll(checked) {
            this.selected = checked ? this.departments.slice() : [];
        },

        // Abdulah 13-05-26 added this
        setFirstPage() {
            this.pagination.currentPage = 1;
            this.length = this.temp_length;
        },
        getDepartments: function () {
            /*departments_option: [{ text: 'First Check', value: 'first' },
                            { text: 'Second Check', value: 'second' },
                            { text: 'Third Check', value: 'third' }],

            departments: ['first' , 'second' , 'third'],*/

            if (!this.checkNet()) return false;
            let currentObj = this;
            axios.get(this.$api_url + '/department/list/details').then(function (response) {

                this.departments_option = response.data.depertments;
                this.departments = response.data.ids;

            }.bind(this)).catch(function (error) { currentObj.serverError(error); });

        },
        getDocumentList: function () {
            if (!this.checkNet()) return false;
            let currentObj = this;
            axios.get(this.$api_url + '/hr-policy-handbook', {
                params: {
                    //employee_id: this.employeeId
                }
            }).then(function (response) {
                this.documents = response.data;

                // Abdullah 13-05-26 added this
                this.pagination.total = response.data.length;

                if (this.documents.length == 0)
                    this.blankmsg = "No doucments found";

                else {
                    this.sortOrders['created_at'] = 1;
                    this.sortBy('created_at');
                }



            }.bind(this)).catch(function (error) { currentObj.serverError(error); });
        },
        editDocument: function (x) {
            if (!this.checkNet()) return false;
            let currentObj = this;


            axios.get(this.$api_url + '/hr-policy-handbook/details', {
                params: {
                    id: x
                }
            }).then(function (response) {
                this.fdata = response.data;

                if (response.data.departments != null)
                    this.selected = response.data.departments.split(",");

                this.$validator.reset();

                this.$bvModal.show('bv-modal-hr');
                // alpha fix- added this
                this.hr_policies = "Edit Company Documents & Policies";

            }.bind(this)).catch(function (error) { currentObj.hr_showoverlay = false; currentObj.serverError(error); });

        },
        deleteDocument(id) {
            if (!this.checkNet()) return false;
            let currentObj = this;

            // alpha fix- chnaged work location to document
            this.$bvModal.msgBoxConfirm('Please confirm that you want to delete this document.', {
                title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false, centered: true
            })
                .then(value => {
                    if (value) {

                        this.hr_showoverlay = true;
                        let formData = new FormData();
                        formData.append('id', id);

                        axios.post(this.$api_url + '/hr-policy-handbook/delete', formData).then(function (response) {

                            if (response.data.status == true) {
                                this.$bvToast.toast(response.data.meg, {
                                    title: `Success`,
                                    variant: 'success',
                                    solid: true
                                });

                                this.getDocumentList();

                            }
                            else {
                                this.$bvToast.toast(response.data.meg, {
                                    title: `Warning`,
                                    variant: 'warning',
                                    solid: true
                                });
                            }

                            this.resetPagination();
                            this.hr_showoverlay = false;

                        }.bind(this))
                            .catch(function (error) {
                                currentObj.hr_showoverlay = false;
                                currentObj.serverError(error);
                            });
                    }
                })
                ;
        },
        validateState(ref) {
            if (
                this.veeFields[ref] &&
                (this.veeFields[ref].dirty || this.veeFields[ref].validated)
            ) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        resetForm() {
            this.fdata = { id: null, name: '' };

            this.$nextTick(() => {
                this.$validator.reset();
            });
        },
        addNew() {
            this.resetForm();
            this.$bvModal.show('bv-modal-hr');
            // alpha fix- added this
            this.hr_policies = "Add Company Documents & Policies";
        },
        onSubmit(e) {
            if (!this.checkNet()) return false;
            this.warningmsg = null;
            this.successmsg = null;


            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }

                // Abdullah 13-04-26 added this
                this.showoverlay = true;

                e.preventDefault();
                let currentObj = this;
                const config = {
                    headers: { 'content-type': 'multipart/form-data' }
                }

                let formData = new FormData();

                if (this.upload_file)
                    formData.append('upload_file', this.upload_file);

                this.fdata.departments = this.selected;

                for (let [key, value] of Object.entries(this.fdata)) {
                    var nm = `${key}`;
                    var fval = `${value}`;
                    formData.append(nm, fval);
                    //console.log(`${key}: ${value}`);
                }

                axios.post(this.$api_url + '/hr-policy-handbook/details', formData, config)
                    .then(function (response) {
                        //console.log(response.data);
                        this.getDocumentList();

                        this.$bvToast.toast('Saved!', {
                            title: `Success`,
                            variant: 'success',
                            solid: true
                        });

                        // Abdullah 13-04-26 added this
                        this.showoverlay = false;
                        this.resetForm();

                        this.$bvModal.hide('bv-modal-hr');

                    }.bind(this))
                    .catch(function (error) {
                        // Abdullah 13-04-26 added this
                        this.showoverlay = false;

                        currentObj.serverError(error);
                        currentObj.errormsg = error.response.data.errors;
                    });
            });
        },

    },
    watch: {
        selected(newValue, oldValue) {
            // Handle changes in individual flavour checkboxes
            if (newValue.length === 0) {
                this.indeterminate = false
                this.allSelected = false
            } else if (newValue.length === this.departments.length) {
                this.indeterminate = false
                this.allSelected = true
            } else {
                this.indeterminate = true
                this.allSelected = false
            }
        }
    },
    created: function () {
        this.getDocumentList();
        this.getDepartments();
        Fire.$on('reloaddocuments', () => { this.getDocumentList() })
    },
    computed:
    {
        filteredData() {
            let filtered_list = this.documents;
            if (this.search) {
                filtered_list = filtered_list.filter((row) => { return Object.keys(row).some((key) => { return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1; }) });

                if (filtered_list.length == 0)
                    this.blankmsg = "No doucments found";
            }

            let sortKey = this.sortKey;
            let order = this.sortOrders[sortKey] || 1;
            if (sortKey) {
                filtered_list = filtered_list.slice().sort((a, b) => {
                    let index = this.getIndex(this.columns, 'name', sortKey);
                    a = String(a[sortKey]).toLowerCase();
                    b = String(b[sortKey]).toLowerCase();
                    if (this.columns[index].type && this.columns[index].type === 'date') {
                        return (a === b ? 0 : new Date(a).getTime() > new Date(b).getTime() ? 1 : -1) * order;
                    }
                    else if (this.columns[index].type && this.columns[index].type === 'number') {
                        return (+a === +b ? 0 : +a > +b ? 1 : -1) * order;
                    }
                    else {
                        return (a === b ? 0 : a > b ? 1 : -1) * order;
                    }
                }
                );
            }

            return filtered_list;
        },
        paginatedData() {
            return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
        }
    }
}
</script>
